export const fieldStyles = {
    '& .MuiOutlinedInput-root': {
        width: '300px',
        height: '36px',
        borderRadius: '8px',
        '& fieldset': {
            borderColor: '#054254',
        },
        '&:hover fieldset': {
            borderColor: '#054254',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#054254',
        },
        '&.Mui-error fieldset': {
            borderColor: 'red',
        },
    },
};